import * as React from 'react';
import classNames from 'classnames';
import {
  Form,
  ConfigProvider,
  type FormProps,
  type FormInstance,
} from 'antd';

export type FormLabelAlign = 'left' | 'right';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
  labelAlign: 'right' as FormLabelAlign,
};

const InternalForm: React.ForwardRefRenderFunction<FormInstance, FormProps> = (props, ref) => {
  const {
    prefixCls,
    className,
    children,
    ...rest
  } = props;
  const { getPrefixCls } = React.useContext(ConfigProvider.ConfigContext);
  const formClassName = getPrefixCls('editForm', prefixCls);
  return <Form
    className={classNames(className, formClassName)}
    prefixCls={prefixCls}
    children={children as React.ReactNode}
    ref={ref}
    {...layout}
    {...rest}
  />;
};

const EditForm = React.forwardRef<FormInstance, FormProps>(InternalForm) as <Values = any>(
  props: React.PropsWithChildren<FormProps<Values>> & { ref?: React.Ref<FormInstance<Values>> },
) => React.ReactElement;

export default EditForm;
